// extracted by mini-css-extract-plugin
export default {"container":"wO-z","topReviewHeading":"xO-z","criticalReview":"yO-z","favorableReview":"zO-z","vsSeparator":"AO-z"};